import {Helmet} from "react-helmet";
import {useEffect} from "react";
import {useNavigate} from "react-router-dom";




function AccountPage({user}) {
    const navigate = useNavigate();
    useEffect(() => {
        if (user.id === null) {
            navigate('/login');
            }
    }, [user.id, navigate]);


    return (<div>
        <Helmet>
            <title>משכנתא דאטה | עריכת חשבון </title>
            <meta name="description" content="ממשק חשבון"/>
        </Helmet>
        <br />
        <div style={{marginRight: '250px', marginTop: '75px'}}>
            <h2 className="my-text-gradient">החשבון שלי</h2>
            <p>{user.name}</p>
        </div>

    </div>);
}

export default AccountPage;
